import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

import arrow from '../assets/arrow.png';

const bg1 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/work-background-first.png';
const fg1 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/work-image-first.png';
const bg2 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/work-background-second.png';
const fg2 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/work-image-second.png';
const bg3 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/work-background-third.png';
const fg3 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/work-image-third.png';

const slides = [
  {
    background: bg1,
    foreground: fg1,
    title: 'Meet a Persona',
    description: (
      <>
        Never met one before? Here’s your chance. We’ll randomly connect you with someone new — and you’ve got 5 minutes to decide if it’s a match. If you both Tap to Connect, the timer disappears and you’ll be permanently linked, ready to find each other anytime in your contacts.
      </>
    ),
    descriptionMobile: (
      <>
        Here’s your chance to randomly meet<br /> someone new. You’ll get 5 minutes to<br /> decide — if you both Tap to Connect,<br /> the timer vanishes and you’re instantly<br /> added to each other’s contacts.
      </>
    ),
    number: '01',
  },
  {
    background: bg2,
    foreground: fg2,
    title: 'Cross Fingers',
    description: (
      <>
        Here’s the catch: the other person won’t know you’ve tapped to connect. So bring yourbest behavior, hope they want to stay in touch too — and in the meantime, keep yourfingers crossed!
      </>
    ),
    descriptionMobile: (
      <>
        Here’s the catch: the other person won’t<br /> know you’ve tapped to connect. So<br /> bring your best behavior, hope they<br /> want to stay in touch too — and in the<br /> meantime, keep your fingers crossed!
      </>
    ),
    number: '02',
  },
  {
    background: bg3,
    foreground: fg3,
    title: 'Build a connection',
    description: (
      <>
        Once both are connected, the call becomes even more personal. The timer fades away, and you get to learn more about the person’s profile — opening the door for deeper conversations.
      </>
    ),
    descriptionMobile: (
      <>
        Once both are connected, the call<br /> becomes even more personal. The timer<br /> fades away, and you get to learn more<br /> about the person’s profile — opening<br /> the door for deeper conversations.
      </>
    ),
    number: '03',
  },
];

const getArrowStyle = (isTablet) => ({
  position: 'absolute',
  top: isTablet ? '22%' : '30%',
  transform: 'translateY(-50%)',
  zIndex: 2,
  width: 75,
  height: 75,
  borderRadius: '50%',
  backgroundColor: '#000000',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  color: '#fff',
  fontSize: 50,
});

const HowItWorks = () => {
  const isMobile = useMediaQuery('(max-width:439px)');
  const isTablet = useMediaQuery('(min-width:440px) and (max-width:1024px)');

  const SlideBlock = ({ slide }) => (
    <Box sx={{ width: '100%', px: { xs: 0, sm: 2 }, mb: { xs: 8, sm: 5 } }}>
      <Box
        sx={{
          backgroundImage: `url(${slide.background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: isMobile ? '24px' : '14px',
          overflow: 'hidden',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: isMobile ? 2 : 8,
          py: isMobile ? 8 : 8,
        }}
      >
        <Box
          component="img"
          src={slide.foreground}
          alt={slide.title}
          sx={{
            maxWidth: '100%',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
          }}
        />
      </Box>

      <Box textAlign="left" sx={{ mt: isMobile ? 3 : 6 }}>
        <Box display="flex" alignItems="baseline" gap={1}>
          <Typography
            sx={{
              color: '#FFFFFF',
              fontFamily: 'Unbounded, sans-serif',
              fontWeight: isMobile ? 500 : 600,
              fontSize: isMobile ? '28px' : isTablet ? '30.43px' : '42px',
              opacity: 0.25,
              mr: 1,
            }}
          >
            {slide.number}
          </Typography>
          <Typography
            sx={{
              color: '#FFFFFF',
              fontFamily: 'Sora, sans-serif',
              fontWeight: 600,
              fontSize: isMobile ? '28px' : isTablet ? '30.43px' : '42px',
            }}
          >
            {slide.title}
          </Typography>
        </Box>

        <Typography
          sx={{
            color: '#FFFFFF',
            fontFamily: 'Sora, sans-serif',
            fontWeight: 400,
            fontSize: isMobile ? '14px' : '16px',
            lineHeight: isMobile ? '23px' : '26px',
            opacity: 0.75,
            mt: 2,
            ml: isMobile ? '60px' : '0px',
          }}
        >
          {isMobile ? slide.descriptionMobile : isTablet ? slide.descriptionMobile : slide.description}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        maxWidth: '1920px',
        mx: 'auto',
        px: isMobile ? 2 : 6,
        pt: isMobile ? '20px' : '100px',
        pb: isMobile ? '50px' : '100px',
      }}
    >
      {isMobile && (
        <Box
          sx={{
            textAlign: 'center',
            mx: 'auto',
            mt: 2,
            mb: 12,
          }}
        >
          <Typography
            sx={{
              color: '#FFFFFF',
              fontFamily: 'Sora, sans-serif',
              fontWeight: 400,
              fontSize: '22px',
              lineHeight: '32px',
            }}
          >
            An essential social<br /> experience for the Apple<br /> Vision Pro
            community to<br /> meet, connect, and discover<br /> new people
            in the era of<br /> Spatial Computing.
          </Typography>
        </Box>
      )}

      {isMobile ? (
        <Typography
          sx={{
            color: '#FFFFFF',
            fontFamily: 'Unbounded, sans-serif',
            fontWeight: 500,
            fontSize: isMobile ? '33.6px' : '50px',
            lineHeight: '130%',
            mb: isMobile ? '40px' : '50px',
            ml: isMobile ? '0px' : '20px',
          }}
        >
          So how does it<br /> work?
        </Typography>
      ) : (
        <Typography
          sx={{
            color: '#FFFFFF',
            fontFamily: 'Unbounded, sans-serif',
            fontWeight: 500,
            fontSize: isMobile ? '28px' : isTablet ? '30.43px' : '50px',
            lineHeight: '100%',
            mb: isMobile ? '40px' : '50px',
            ml: isMobile ? '0px' : '20px',
          }}
        >
          So how does it work?
        </Typography>
      )}

      {isMobile ? (
        <Box>
          {slides.map((slide, i) => (
            <SlideBlock key={i} slide={slide} />
          ))}
        </Box>
      ) : (
        <Box sx={{ position: 'relative' }}>
          <AliceCarousel
            items={slides.map((slide, i) => <SlideBlock key={i} slide={slide} />)}
            responsive={{
              0: { items: 1 },
              768: { items: 2 },
            }}
            disableDotsControls
            renderPrevButton={() => (
              <Box sx={{ ...getArrowStyle(isTablet), left: -20 }}>
                <Box
                  component="img"
                  src={arrow}
                  alt="Prev"
                  sx={{ width: 12, height: 20, transform: 'rotate(180deg)' }}
                />
              </Box>
            )}

            renderNextButton={() => (
              <Box sx={{ ...getArrowStyle(isTablet), right: -20 }}>
                <Box
                  component="img"
                  src={arrow}
                  alt="Next"
                  sx={{ width: 12, height: 20 }}
                />
              </Box>
            )}
            controlsStrategy="responsive"
          />
        </Box>
      )}
    </Box>
  );
};

export default HowItWorks;
